module.exports = __webpack_public_path__ + "img/md.a6e66017.png";